export default __webpack_public_path__ + "static/media/default-bg.3276b0ab.png";